import React, {useEffect, useState, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../Helpers/Auth';
import {Collapse, initTE} from 'tw-elements';
import Datepicker from 'react-tailwindcss-datepicker';
import Spinner from '../../../components/Spinner';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';
import SelectComponent from '../../Selects/SelectComponentFilt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import moment from 'moment';
import NotFound from '../../NotFound';
import MultiSelect from '../../Selects/MultiSelectComponent';
import {toast} from 'react-toastify';
import axios from 'axios';
import {getRelatorios} from '../../../pages/requests';

function Table({
    onRowClick,
    loading,
    setLoading,
    filtroCodigo,
    setFiltroCodigo,
    setFiltroData,
    filtroData,
    filtroNegocio,
    setFiltroNegocio,
    filtroGestorCliente,
    setFiltroGestorCliente,
    filtroMarca,
    setFiltroMarca,
    filtroCliente,
    setFiltroCliente,
    filtroObs,
    setFiltroObs,
    filtroMotivo,
    setFiltroMotivo,
    filtroValor,
    setFiltroValor,
    filtroConcorrencia,
    setFiltroConcorrencia,
    filtroMarcaModelo,
    setFiltroMarcaModelo,
    arrayConcorrentes,
    arrayGestorCliente,
    arrayMarcas,
    arrayMotivos,
}) {
    const {t} = useTranslation();
    const {isCard, openCards, utilizador} = useContext(Context);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);
    const [relatorios, setRelatorios] = useState([]);
    const [semDados, setSemDados] = useState(false);
    const FORMATO_DATA = 'YYYY-MM-DD';
    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setRelatorios([]);
        setLoading(true);
        setSemDados(false);
        getRelatorios(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroCodigo,
            filtroData.startDate ?? '',
            filtroNegocio,
            filtroGestorCliente,
            filtroMarca?.value ?? '',
            filtroCliente,
            filtroObs,
            filtroMotivo?.value ?? 0,
            Number(filtroValor),
            filtroConcorrencia?.value ?? '',
            filtroMarcaModelo,
        )
            .then(res => {
                if (res.data.success) {
                    setRelatorios(res.data.relatorios);
                    setTotalLinhas(res.data.totalprodutos);
                    if (res.data.totalprodutos == 0) {
                        setSemDados(true);
                    }
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroData.startDate, filtroNegocio, filtroGestorCliente, filtroMarca, filtroCliente, filtroObs, filtroMotivo, filtroValor, filtroConcorrencia, filtroMarcaModelo, filtroCodigo]);

    initTE({Collapse});

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const ITEMS_PER_PAGE = 15;

    const filtrosAplicados = () => {
        return (
            filtroData.startDate ||
            filtroNegocio ||
            filtroGestorCliente?.length != 0 ||
            filtroMarca ||
            filtroCliente ||
            filtroObs ||
            filtroMotivo ||
            filtroValor ||
            filtroConcorrencia ||
            filtroMarcaModelo
        );
    };

    function limparFiltros() {
        setFiltroData({startDate: null, endDate: null});
        setFiltroNegocio('');
        setFiltroCliente('');
        setFiltroGestorCliente([]);
        setFiltroMarca(null);
        setFiltroObs('');
        setFiltroMotivo(null);
        setFiltroValor(0);
        setFiltroConcorrencia(null);
        setFiltroMarcaModelo('');
    }
    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {relatorios?.map((dados, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row" onClick={() => onRowClick(dados)}>
                                            {dados.codEmpresa} - {dados.nome}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('codigo')}:</div> {dados.codEmpresa}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('data')}: </div> {moment(dados.dataFecho).format(FORMATO_DATA)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('negocio')}: </div> {dados.nome}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {dados.responsavel.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('marca')}: </div> {dados.marca.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.empresa}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('observacoes')}: </div> {dados.observacoes}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('motivo')}: </div> {dados.motivoPerda.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('valor')}: </div> {dados.valor}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('concorrente')}: </div> {dados.concorrente.descricao}
                                        </div>
                                        <div className="text-gray-500 flex flex-row dark:text-white">
                                            <div className="font-medium text-gray-400 mr-2">{t('marcaModelo')}: </div> {dados.marcaModelo}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                ) : (
                    <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-2 py-3 w-24">
                                        {t('codigo')}
                                        <InputFilter
                                            value={filtroCodigo}
                                            onSearch={value => {
                                                setFiltroCodigo(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-2 py-3 md:w-32 lg:w-44   ">
                                        {t('data')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={true}
                                            value={filtroData}
                                            onChange={newValue => {
                                                setFiltroData(newValue);
                                                setCurrentPage(1);
                                            }}
                                            inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>

                                    <th scope="col" className="px-2 py-3 w-32">
                                        {t('negocio')}
                                        <InputFilter
                                            value={filtroNegocio}
                                            onSearch={value => {
                                                setFiltroNegocio(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-2 py-3">
                                        {t('representante')}
                                        <div className=''>
                                        <MultiSelect
                                            options={arrayGestorCliente}
                                            value={filtroGestorCliente}
                                            onChange={e => {
                                                setFiltroGestorCliente(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        /></div>
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        {t('marca')}
                                        <SelectComponent
                                            options={arrayMarcas}
                                            value={filtroMarca}
                                            onChange={e => {
                                                setFiltroMarca(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className="px-2 py-3 w-32">
                                        {t('cliente')}
                                        <InputFilter
                                            value={filtroCliente}
                                            onSearch={value => {
                                                setFiltroCliente(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-2 py-3 w-96">
                                        {t('observacao')}
                                        <InputFilter
                                            value={filtroObs}
                                            onSearch={value => {
                                                setFiltroObs(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        {t('motivo')}
                                        <SelectComponent
                                            options={arrayMotivos}
                                            value={filtroMotivo}
                                            onChange={e => {
                                                setFiltroMotivo(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className="px-2 py-3 w-32">
                                        {t('valor')}
                                        <InputFilter
                                            type={'number'}
                                            value={filtroValor == 0 ? '' : filtroValor}
                                            onSearch={value => {
                                                setFiltroValor(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        {t('concorrente')}
                                        <SelectComponent
                                            options={arrayConcorrentes}
                                            value={filtroConcorrencia}
                                            onChange={e => {
                                                setFiltroConcorrencia(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3 w-32 px-2">
                                        {t('marcaModelo')}
                                        <div className="flex flex-row">
                                            <InputFilter
                                                value={filtroMarcaModelo}
                                                onSearch={value => {
                                                    setFiltroMarcaModelo(value);
                                                    setCurrentPage(1);
                                                }}
                                            />
                                            {filtrosAplicados() ? (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            ) : null}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {relatorios?.map(dados => {
                                    return (
                                        <tr
                                            className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                            onClick={() => onRowClick(dados)}>
                                            <th scope="row" className="px-2 py-3 w-24 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {dados.num}
                                            </th>

                                            <td className="px-2 py-3 md:w-32 lg:w-44 ">{moment(dados.dataFecho).format(FORMATO_DATA)}</td>
                                            <td className=" px-2 py-3 w-32">{dados.nome}</td>
                                            <td className=" px-2 py-3">{dados.responsavel.label}</td>
                                            <td className="px-2 py-3">{dados.marca.label}</td>
                                            <td className=" px-2 py-3 w-32">{dados.empresa}</td>
                                            <td className="px-2 py-3 w-96">{dados.observacoes}</td>
                                            <td className=" px-2 py-3">{dados.motivoPerda.label}</td>
                                            <td className="px-2 py-3 w-32">{dados.valor}</td>
                                            <td className=" px-2 py-3">{dados.concorrente.descricao}</td>
                                            <td className="py-3 w-32 px-2">{dados.marcaModelo}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {semDados && !loading && <NotFound frase={t('semRegistos')} />}

                        {/* {totalLinhas === undefined && (
                      <NotFound frase={t('naoExistemClientes')} />
                  )} */}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                )}
            </div>
        </>
    );
}

export default Table;
